import { Tooltip } from '@/components';
import { EllipsisIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import { ICaregiverConsultationDto } from '@/caregiverSpace/shared/model';

type ConsultationRoomStatusProps = {
    consultation: ICaregiverConsultationDto;
};

export const ConsultationRoomStatus = ({
    consultation,
}: ConsultationRoomStatusProps) => {
    return (
        <>
            {consultation.IsCaregiverInCall &&
                !consultation.IsInWaitingRoom && (
                    <Tooltip content={R.CaregiverWaiting}>
                        <EllipsisIcon variant="warning" />
                    </Tooltip>
                )}
            {consultation.IsInWaitingRoom &&
                !consultation.IsCaregiverInCall && (
                    <Tooltip content={R.PatientWaiting}>
                        <EllipsisIcon variant="success" />
                    </Tooltip>
                )}
            {consultation.IsInWaitingRoom && consultation.IsCaregiverInCall && (
                <Tooltip content={R.ConsultationInProgress}>
                    <EllipsisIcon variant="warning" className="relative z-5" />
                    <EllipsisIcon
                        variant="success"
                        className="relative -ml-2"
                    />
                </Tooltip>
            )}
        </>
    );
};
